/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/


export enum FilterOptionLayoutEnum {
    "default" = "default",
    "colors" = "colors",
    "personalization" = "personalization",
    "image" = "image"
}

export type FilterOptionLayout = FilterOptionLayoutEnum;